export const SHARE_MODEL = "shared-with";
export const USERS_FOR_SHARING = "users-for-sharing";

const shareModel = {
  users: []
};

export default shareModel;
